
import { IKeHoachMonSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectRequest";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IKeHoachMonHocNamHocHocKyActionTypeBase<T> {
    id_dt: number,
    data: T
}
export const eKeHoachMonHocNamHocHocKyActionsObj = {
    INI_START: {} as IKeHoachMonHocNamHocHocKyActionTypeBase<undefined>,
    LOAD_KE_HOACH_MON_BY_CTDT_START: {} as IKeHoachMonHocNamHocHocKyActionTypeBase<IKeHoachMonSelectRequest>,
    LOAD_KE_HOACH_MON_BY_CTDT_SUCCESS: {} as IKeHoachMonHocNamHocHocKyActionTypeBase<IKeHoachMonViewModel[]>,
    LOAD_KE_HOACH_MON_BY_CTDT_ERROR: {} as IKeHoachMonHocNamHocHocKyActionTypeBase<string>,

};
export const eKeHoachMonHocNamHocHocKyActionIds = generateActionTypeIds(
    eKeHoachMonHocNamHocHocKyActionsObj,
    "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY"
);
export type IKeHoachMonHocNamHocHocKyActionTypes = IGenericActionType<
    typeof eKeHoachMonHocNamHocHocKyActionsObj,
    "KE_HOACH_MON_HOC_NAM_HOC_HOC_KY"
>;
